<template>
  <div class='container'>
    <div class="playing-text" :class="{en: language=== 'EN'}"  v-if="state === 0">
      <h2>{{ language === 'TC' ? '提交成功' : 'Submission successful!' }}</h2>
      <p v-if="language === 'TC'">請跟著店內運動員指示<br/>完成步態掃描體驗</p>
      <p v-else class='en'>Please follow our store athlete's instructions<br/>to complete the foot test experience.</p>
    </div>
    <img class="bottom-logo" src="../assets/image/logo.png" v-if="state === 0" />
    

    <img class="loading" src="../assets/image/loading.gif" v-if="state === 1" />
    <div class="txt_testing"  v-if="state === 1" :class="{en: language=== 'EN'}">
      <h2>{{ language === 'TC' ? '測試中...' : 'Testing... ' }}</h2>
      <p v-if="language === 'TC'">正在生成您的<br/>「步態掃描體驗報告」</p>
      <p v-else class='en'>Generating your<br/>“Foot Scan Test Report”</p>
    </div>


    <div class="complete-text"  v-if="state === 2" :class="{en: language=== 'EN'}">
      <h2>{{ language === 'TC' ? '測試完成' : 'Test complete ' }}</h2>
      <p v-if="language === 'TC'">您的「步態掃描體驗報告」已生成<br/>點擊下方按鈕立即查看</p>
      <p v-else class='en'>Your “Foot Scan Test Report” has been generated.<br/>Click the button below to view it now.</p>
    </div>
    <div class='btn bottom-btn' :class="{en: language=== 'EN'}" v-if="state === 2" @click="toCenter">{{ language === 'TC' ? '查看報告' : 'Check Report' }}</div>

  </div>
</template>

<script>
  import axios from 'axios'

  export default {

    data () {
      return {
        timer: null,
        state: 0,
        
      }
    },
    mounted(){
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(this.getGameStatus, 3000)
      // this.test()
    },
    
    methods:{
      getGameStatus() {
        var me = this
        if (me.timestamp) {
          axios({
            method: 'get',
            url: me.baseUrl + '/scanner/' + me.timestamp,
          }).then(res => {
            if (res.status === 200 && res.data.data && res.data.data.game_status === 1) { // 游戏开始
              me.state = 1
            }
            if (res.status === 200 && res.data.data && res.data.data.pic_url) { // 游戏完成
              clearInterval(me.timer)
              me.timer = null
              me.state = 2
            }

          }).catch(e => {
            console.log('getGameStatus-e :>> ', e)
          })
          
        } else {
           me.$router.replace({ path: "/" })
        }

      },

      // test() {
      //   setTimeout(() => {
      //     this.state = 1
      //   }, 4000)
      //   setTimeout(() => {
      //     this.state = 2
      //   }, 10000)
      // },


      toCenter() {
        this.$router.replace({ path: "/user_center" })
      }
    },

    computed: {
      language() {
        return this.$store.state.language
      },
      timestamp() {
        return this.$store.state.timestamp
      },
      baseUrl() {
        return this.$store.state.baseUrl
      },
    }


  }
</script>


<style lang="less" scoped>

  .playing-text {
    position: absolute;
    top: 60vw;
    left: 0vw;
    width: 100vw;
    display: flex;
    align-items: center;
    flex-direction: column;
    
    &.en {
      h2 {
        font-family: 'en-bold';
      }
      p {
        font-family: 'en-medium';
        font-weight: normal;
      }
    }
    h2 {
      font-family: 'fs-bold';
      font-weight: bold;
      margin-bottom: 5vw;
      font-size: 5.8vw;
      text-align: center;
    }
    p {
      // font-weight: bold;
      font-family: 'fs-regular';
      font-size: 4.2vw;
      text-align: center;
      &.en {
        font-size: 3.7vw;
      }
    }

  }

  .bottom-logo {
    position: absolute;
    bottom: 30vw;
    left: 34.5vw;
    width: 31vw;
  }

  .loading {
    position: absolute;
    top: 25vw;
    left: 18.7vw;
    width: 62.6vw;
    height: 62.6vw;
  }

  .txt_testing {
    position: absolute;
    top: 100vw;
    left: 0vw;
    width: 100vw;
    
    &.en {
      h2 {
        font-family: 'en-bold';
      }
      p {
        font-family: 'en-medium';
        font-weight: normal;
      }
    }
    h2 {
      font-family: 'fs-bold';
      font-weight: bold;
      margin-bottom: 5vw;
      font-size: 5.8vw;
      text-align: center;
    }
    p {
      // font-weight: bold;
      font-size: 4.2vw;
      text-align: center;
      &.en {
        font-size: 3.7vw;
      }
    }
  }

  .complete-text {
    position: absolute;
    top: 60vw;
    left: 0;
    width: 100vw;
    
    &.en {
      h2 {
        font-family: 'en-bold';
      }
      p {
        font-family: 'en-medium';
        font-weight: normal;
      }
    }
    h2 {
      font-family: 'fs-bold';
      font-weight: bold;
      margin-bottom: 5vw;
      font-size: 5.8vw;
      text-align: center;
    }
    p {
      font-family: 'fs-regular';
      // font-weight: bold;
      font-size: 4.2vw;
      text-align: center;
      &.en {
        font-size: 3.7vw;
      }
    }
  }

  .bottom-btn {
    position: absolute;
    top: 120vw;
    left: 29.6vw;
    width: 40.8vw;
    height: 10.6vw;
    background-color: #fff;
    color: #000;
    text-align: center;
    line-height: 10.6vw;
    font-size: 3.2vw;
    font-weight: bold;
    border-radius: 50px;
    font-family: 'fs-bold';
    &.en {
      font-family: 'en-bold';
    }
  }




</style>



// WEBPACK FOOTER //
// src/pages/playing.vue